// Sentry must be imported first to instrument all modules
import './instrument';
import './index.css';

import { getWorkOSClientId } from './auth/workos-config';
import { bootstrapApp, renderBootstrapFailure } from './bootstrap';

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
} as const;

const posthogApiKey = isLocalhost ? '' : import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

const rootEl = document.getElementById('root');

if (!rootEl) {
  throw new Error('Root element not found');
}

/**
 * AuthKitProvider is always rendered so that the useAuth() hook from
 * @workos-inc/authkit-react can be called unconditionally (React hook rules).
 *
 * When WorkOS is disabled (isWorkOSEnabled() === false), AuthKit is
 * effectively inert — the app uses legacy localStorage auth instead.
 * The `devMode` prop stores tokens in localStorage on localhost.
 *
 * The clientId defaults to empty string when not configured — AuthKit
 * handles this gracefully (no-op when not configured).
 */
const workosClientId = getWorkOSClientId() || 'not_configured';

void bootstrapApp(rootEl, {
  workosClientId,
  posthogApiKey,
  posthogOptions,
  isLocalhost,
}).catch((error: unknown) => {
  renderBootstrapFailure(rootEl, error);
});
